import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { appConfigs } from "../../../martin/_helpers";
import { useNavigate } from "react-router-dom";

export default function Home() {
  document.title = appConfigs.app_name + " — " + appConfigs.job_description;
  const navigate = useNavigate();
  useEffect(() => {
    // Check & extract all GET parameters set on URL
    let url_string = window.location.href;
    let url = new URL(url_string);
    // Check for search & redirect appropriately
    let s = url.searchParams.get('s');
    if (s) navigate('/search/' + encodeURIComponent(s));
  });
  return (
    <>
      <div className="martin-narrow-content content-section">
        <div className="row">
          <div className="col-md-12">
            <div className="row row-bottom-padded-sm">
              <div className="col-md-12">
                <div className="about-desc">
                  <span className="heading-meta">About Martin</span>
                  {/* <h2 className="martin-heading">Who Am I?</h2> */}
                  <p><strong>Hello, I'm Martin Nzuki</strong>. Nice to meet you!</p>
                  <p>I'm passionate about building excellent software that improves the lives of those around me. I specialize in creating software for clients ranging from individuals &amp; small-businesses all the way to large enterprise corporations.</p>
                  <p>I have over the years done work in software development, mobile app creation, web front-end &amp; back-end, database/server management, &amp; graphic design. I really value simple content structures, clean design patterns, and intuitive user experiences.</p>
                  {/* <p>Currently, I'm working full time as a front-end developer at <span className="fancy-link"><a href="https://azenia.com" target="_blank" rel="noreferrer">Azenia Technology</a></span>.</p> */}
                  {/* <p>I really value simple content structures, clean design patterns, and intuitive user experiences. I <em>speak</em> a lot of <strong>Angular</strong> &amp; <strong>React</strong> on my web front-ends, <strong>Node.js</strong> on my APIs</p> */}
                </div>
              </div>
            </div>
            <div className="row row-bottom-padded-md">
              <div className="col-md-12">
                <div className="hire">
                  <h2 style={{ lineHeight: '1.2', marginBottom: '0' }}>
                    I believe that every project should be
                    <br />approached with attention to detail &amp; determination
                    <br />to exceed expectations.
                  </h2>
                  {/* <a href="#" data-nav-section="contact" className="btn-hire">Hire me</a> */}
                </div>
              </div>
            </div>
            <div className="row row-bottom-padded-sm">
              <div className="col-md-12">
                <div className="about-desc">
                  <p>I'm also passionate about UI/UX. I occasionally create intuitive <strong>app designs</strong> using <strong>Figma</strong>. Feel free to have a look at some of my works on the <span className="fancy-link"><Link to="/apps" className="">portfolio</Link></span> page.</p>
                  <p>A couple of years ago, I stumbled on Google's <strong>Flutter</strong> framework for creating cross-platform applications. Since then, I've been playing with it and developing cool Android applications on my free time. You can check 'em out on <span className="fancy-link"><a href="https://play.google.com/store/apps/dev?id=5259823913189902275" target="_blank" rel="noreferrer">Play Store</a></span>.</p>
                </div>
              </div>
            </div>
            <div className="row d-none">
              <div className="col-md-4">
                <div className="services color-4">
                  <span className="icon2"><i className="icon-phone3"></i></span>
                  <h3>
                    <span>App Development</span><br /><br />
                    <small>Innovative Android &amp; iOS applications, fast, slick, latest trends.</small>
                  </h3>
                </div>
              </div>
              <div className="col-md-4">
                <div className="services color-2">
                  <span className="icon2"><i className="icon-data"></i></span>
                  <h3>
                    <span>Web Development</span><br /><br />
                    <small>Awesome front ends, secure &amp; dynamic APIs, latest tech.</small>
                  </h3>
                </div>
              </div>
              <div className="col-md-4">
                <div className="services color-1">
                  <span className="icon2"><i className="icon-bulb"></i></span>
                  <h3>
                    <span>UI/UX Design</span><br /><br />
                    <small>Beautiful interfaces &amp; amazing user experiences.</small>
                  </h3>
                </div>
              </div>
            </div>
            <div className="row row-bottom-padded-sm d-none">
              <div className="col-md-12">
                <div className="about-desc">
                  <p>Aside from coding and designing, I also enjoy spending time with my wife Juliet and my daughter Skye, reading self-development books, watching movies and going for evening joggings.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}